import { AddPreSoldMembershipFormValues } from './add-pre-sold-membership-form';
import { PsmPayload } from './add-pre-sold-membership-modal';

export const MAX_PRICE = 99999999;

export function convertPriceToCents(price: number) {
  return Math.round(price * 100);
}

export function getIntervalFromLengthInMonths(lengthInMonths: number): {
  intervalCount: number;
  intervalUnit: 'month' | 'year';
} {
  return {
    intervalCount: lengthInMonths < 12 ? lengthInMonths : Math.floor(lengthInMonths / 12),
    intervalUnit: lengthInMonths < 12 ? 'month' : 'year',
  };
}

/** Length options ordered by duration (shortest first). */
export const preSoldLengths = [
  { label: '6 months', value: 6 },
  { label: '9 months', value: 9 },
  { label: '10 months', value: 10 },
  { label: '11 months', value: 11 },
  { label: '1 year', value: 12 },
  { label: '2 years', value: 24 },
  { label: '3 years', value: 36 },
];

export function preparePreSoldMembershipData(
  data: AddPreSoldMembershipFormValues,
): PsmPayload {
  const { intervalUnit, intervalCount } = getIntervalFromLengthInMonths(data.lengthInMonths);
  const amount = convertPriceToCents(data.price);

  return {
    amount,
    intervalUnit,
    intervalCount,
    partnerProductId: data.partnerProductId,
  };
}

export function convertPriceToDollars(price: number) {
  return price / 100;
}

export function getLengthInMonthsFromInterval(intervalCount: number, intervalUnit: string) {
  return intervalUnit === 'month' ? intervalCount : intervalCount * 12;
}

export enum AddPreSoldMembershipFormFields {
  Price = 'price',
  LengthInMonths = 'lengthInMonths',
  PartnerProductId = 'partnerProductId',
}

export const PRE_SOLD_MEMBERSHIP_SECTION = 'preSoldMembership';

export const PreSoldMembershipSectionField = {
  Price: 'preSoldMembership.price',
  LengthInMonths: 'preSoldMembership.lengthInMonths',
  PartnerProductId: 'preSoldMembership.partnerProductId',
} as const satisfies Record<
  keyof typeof AddPreSoldMembershipFormFields,
  `${typeof PRE_SOLD_MEMBERSHIP_SECTION}.${AddPreSoldMembershipFormFields}`
>;
